module.exports = __webpack_public_path__ + "h5/img/404.10fbd11c.png";